import { BaseError } from "./BaseError.ts";

interface ErrorMessage {
  readonly message?: string;
  readonly userPresentableMessage: string;
}

export class PaymentRequiredError extends BaseError {
  public override readonly name: string = "PaymentRequiredError";

  public override readonly userPresentableMessage: string;

  public constructor(message: ErrorMessage, errorOptions?: ErrorOptions) {
    super(message, errorOptions);
    this.userPresentableMessage = message.userPresentableMessage;
  }
}
